import React, { useEffect, useState } from 'react';
import Button from '../../FlyfishComponents/Button';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import AutoComplete from '../../FlyfishComponents/AutoComplete';
import Checkbox from '../../FlyfishComponents/Checkbox';
import Input from '../../FlyfishComponents/Input';
import styled from 'styled-components';
import { TOASTER } from '../ChatBody';
import {
	loadState,
	loadStateSession,
	removeState,
	saveState,
	saveStateSession,
} from '../../FlyfishComponents/flyfishutils/utils';

const FORMS = styled.div`
	width: 100%;
	& > div {
		& > p {
			color: ${(props) => {
				if (props.cssPtag) {
					return 'var(--colorScale-1)';
				}
				return props.colorMode === 'dark' ? 'white' : 'var(--colorScale-1)';
			}};
			margin-bottom: 6px !important;
			margin-top: 24px !important;
			font-weight: 600;
			&.ff-chatbot-caption {
				margin: 0 !important;
				margin-bottom: 6px !important;
				font-weight: normal;
				color: ${(props) => {
					if (props.cssPtag) {
						return 'var(--black-60)';
					}
					return props.colorMode === 'dark' ? 'white' : 'var(--black-60)';
				}};
			}
		}
		& > .ff-checkbox {
			margin-bottom: 16px;
			& > label {
				gap: 8px;
				& > .check {
					& path:last-child {
						fill: ${(props) => {
							if (props.cssPtag) {
								return 'var(--black-60) !important';
							}
							return props.colorMode === 'dark'
								? 'white'
								: 'var(--colorScale-1)';
						}};
					}
					&.checked {
						& path:last-child {
							fill: ${(props) => {
								if (props.cssPtag) {
									return 'var(--colorScale-1) !important';
								}
								return props.colorMode === 'dark'
									? 'white'
									: 'var(--colorScale-1)';
							}};
						}
					}
				}
				& > .label {
					& > p {
						margin: 0 !important;
						color: ${(props) => {
							if (props.cssPtag) {
								return 'initial !important';
							}
						}};
					}
				}
			}
		}
		& > .MuiFormGroup-root {
			margin-bottom: 16px;
			margin-left: 2px;
			gap: 16px;
			& > label {
				& > .MuiTypography-root {
					& > p {
						margin: 0 !important;
						color: ${(props) => {
							if (props.cssPtag) {
								return 'initial !important';
							}
							return props.colorMode === 'dark'
								? 'white'
								: 'var(--colorScale-1)';
						}};
					}
				}
				& > span.MuiButtonBase-root {
					padding: 0px 9px !important;
					& path {
						fill: ${(props) => {
							if (props.cssPtag) {
								return 'var(--black-60) !important';
							}
							return props.colorMode === 'dark'
								? 'white'
								: 'var(--colorScale-1)';
						}};
					}
					&.Mui-checked {
						& path {
							fill: ${(props) => {
								if (props.cssPtag) {
									return 'var(--colorScale-1) !important';
								}
								return props.colorMode === 'dark'
									? 'white'
									: 'var(--colorScale-1)';
							}};
						}
					}
				}
			}
		}
		& > div > .MuiFormControl-root {
			padding: 0 !important;
			& input {
				font-size: 14px !important;
				color: var(--black-60);
			}
			& .MuiFormHelperText-root {
				margin-left: 0 !important;
			}
			& .MuiInputBase-root {
				&.Mui-error {
					.MuiOutlinedInput-notchedOutline {
						border-color: var(--colorScale-1);
					}
				}

				background-color: white;
				&:not(.Mui-disabled, .Mui-error).Mui-focused {
					.MuiOutlinedInput-notchedOutline {
						border-color: ${(props) => {
							if (props.cssPtag) {
								return 'var(--colorScale-1) !important';
							}
							return props.colorMode === 'dark'
								? 'white'
								: 'var(--colorScale-1)';
						}};
					}
				}
			}
			& .MuiFormHelperText-root {
				color: ${(props) => {
					if (props.cssPtag) {
						return 'var(--colorScale-1) !important';
					}
					return props.colorMode === 'dark' ? 'white' : 'var(--colorScale-1)';
				}};
			}
		}

		& > div {
			& > .MuiAutocomplete-root {
				margin-bottom: 24px !important;
				& .MuiInputBase-root {
					background-color: white;
					padding: 6px !important;
					padding-left: 10px !important;

					&:not(.Mui-disabled, .Mui-error).Mui-focused {
						.MuiOutlinedInput-notchedOutline {
							border-color: var(--colorScale-1) !important;
						}
					}
				}
			}
		}
	}
	& > div {
		& > .custom-button {
			max-width: 220px;
		}
		& > .custom-button:last-child {
			padding-top: 12px;
			width: ${(props) => (props.cssPtag ? '25%' : '90px')};
			& > button {
				background-color: ${(props) => {
					return props.colorMode === 'dark'
						? 'var(--colorScale-9)'
						: 'var(--colorScale-8)';
				}} !important;
				& > .custom-button-body {
					font-family: var(--fontFamily);
					color: ${(props) => {
						return props.colorMode === 'dark'
							? 'var(--selectedColor)'
							: 'var(--colorScale-3)';
					}} !important;
				}
			}
		}
		& > .custom-button:first-child {
			padding-top: 12px;
			width: ${(props) => (props.cssPtag ? '25%' : '90px')};
			& > button {
				background-color: ${(props) => {
					if (props.cssPtag) {
						return props.colorMode === 'dark'
							? 'var(--selectedColor)'
							: 'var(--colorScale-2) ';
					}
					return props.colorMode === 'dark' ? 'white' : 'var(--colorScale-2)';
				}} !important;
				& > .custom-button-body {
					font-family: var(--fontFamily);
					color: ${(props) => {
						if (props.cssPtag) {
							return 'white';
						}
						return props.colorMode === 'dark'
							? 'var(--selectedColor)'
							: 'white';
					}} !important;
				}
				& > .button-loader {
					display: flex;
					color: ${(props) => {
						if (props.cssPtag) {
							return 'white';
						}
						return props.colorMode === 'dark'
							? 'var(--selectedColor)'
							: 'white';
					}} !important;
				}
				& > .button-loader {
					display: flex;
					color: ${(props) => {
						if (props.cssPtag) {
							return 'white';
						}
						return props.colorMode === 'dark'
							? 'var(--selectedColor)'
							: 'white';
					}} !important;
				}
			}
		}
	}
`;

type Props = {
	handleSubmit: Function;
	WorkflowData: any;
	colorMode: string;
	token: any;
	botId: any;
	tenantId: any;
	conversationId: any;
	cssPtag?: any;
	addUserResponse: Function;
	currentWorkflow: string;
	changeScreen?: Function;
	showToaster?: Function;
	disableMandatory?: Function;
	shouldDisableActions?: any;
	noOfTimeCalled?: number;
	maxIndex?: number;
	EbotId: string;
	lang: string;
};

const InfoIcon = (colorMode, cssPtag) => {
	let color = '';
	if (colorMode === 'dark') {
		if (cssPtag) {
			color = 'var(--colorScale-1)';
		} else {
			color = 'white';
		}
	} else {
		color = 'var(--colorScale-1)';
	}
	return (
		<svg
			style={{ position: 'relative', bottom: '1px' }}
			xmlns='http://www.w3.org/2000/svg'
			width='13.909'
			height='13.909'
			viewBox='0 0 13.909 13.909'
		>
			<path
				d='M8.259 11.041H9.65v1.391H8.259zm0-5.564H9.65V9.65H8.259zM8.947 2a6.954 6.954 0 1 0 6.961 6.954A6.951 6.951 0 0 0 8.947 2zm.007 12.518a5.564 5.564 0 1 1 5.564-5.564 5.562 5.562 0 0 1-5.564 5.564z'
				transform='translate(-2 -2)'
				fill={color}
			/>
		</svg>
	);
};

const GetInTouch = ({
	handleSubmit,
	WorkflowData,
	colorMode,
	botId,
	tenantId,
	token,
	conversationId,
	cssPtag,
	changeScreen,
	addUserResponse,
	currentWorkflow,
	showToaster,
	disableMandatory,
	shouldDisableActions,
	noOfTimeCalled,
	maxIndex,
	lang,
	EbotId,
}: Props) => {
	const [currentWorkflowData, setCurrentWorkflowData] = useState<any>(
		currentWorkflow === 'generateLeads'
			? WorkflowData[1]
			: currentWorkflow === 'raiseTicket'
			? WorkflowData[0]
			: currentWorkflow === 'bookAppointment'
			? WorkflowData[2]
			: WorkflowData[1]
	);
	const [sortedWorkflowData, setSortedWorkflowData] = useState<any>();
	const [workflowValues, setWorkflowValues] = useState<any>();
	const [disableButton, setDisableButton] = useState(false);
	const [showErrorToaster, setErrorToaster] = useState(false);
	const [submitLoader, setSubmitLoader] = useState(false);
	// const [initialState, setInitialState] = useState(true)
	const [disableInputs, setDisableInputs] = useState(
		maxIndex !== noOfTimeCalled
	);

	const validationCheck = () => {
		let validation = sortedWorkflowData.map((list, index) => {
			if (list.enabled.toLowerCase() === 'true') {
				let validator = new RegExp(list.validation, 'i');

				if (list.validationType.toLowerCase() === 'multiple choice') {
					return !workflowValues[index];
				} else if (list.validationType.toLowerCase() === 'multiple select') {
					if (workflowValues[index]) {
						let check = workflowValues[index].select.filter(
							(v) => v[0] === true
						);
						return check[0] === undefined ? true : false;
					}
					return false;
				} else if (list.validationType.toLowerCase() === 'drop down') {
					return false;
				}

				return workflowValues[index] && !validator.test(workflowValues[index]);
			}
		});
		// console.log('Validation', validation);
		let filterTrue = validation.filter((value) => value === true)[0];
		let filterEmpty = validation.filter((value) => value === '');
		// console.log('filterTrue', filterTrue);

		// console.log('filterEmpty', filterEmpty);
		let buttonDisable = false;
		if (filterTrue === undefined && filterEmpty.length === 0) {
			buttonDisable = false;
		} else {
			buttonDisable = true;
		}
		return buttonDisable;
	};

	const errTextAndIconColor = (colorMode) => {
		if (colorMode === 'dark') {
			if (cssPtag) {
				return 'var(--colorScale-1)';
			}
			return 'white';
		} else {
			return 'var(--colorScale-1)';
		}
	};

	useEffect(() => {
		return () => {
			if (cssPtag) {
				workflowValues &&
					saveStateSession(
						`FF-CSSPTAGworkflowData-${noOfTimeCalled}`,
						workflowValues
					);
			} else {
				workflowValues && saveStateSession('FF-workflowData', workflowValues);
			}
		};
	}, [workflowValues]);
	useEffect(() => {
		if (cssPtag) {
			setTimeout(() => {
				const chatbodyWrapper = document.querySelector('.sf-chatbody');
				chatbodyWrapper.scrollTo({ top: chatbodyWrapper.scrollHeight });
			}, 100);
		}
	}, []);

	useEffect(() => {
		if (currentWorkflowData.task) {
			let tasks = currentWorkflowData.task;
			tasks.sort((a, b) => parseInt(a.sequence, 10) - parseInt(b.sequence, 10));
			setSortedWorkflowData(tasks);
			let workflowData = tasks.map((item, i) => {
				if (item.enabled.toLowerCase() === 'true') {
					if (item.validationType.toLowerCase() === 'drop down') {
						return { label: item.options[0].name, value: item.options[0].name };
					} else if (item.validationType.toLowerCase() === 'multiple choice') {
						return '';
					} else if (item.validationType.toLowerCase() === 'multiple select') {
						let v = item.options.map((list, idx) => {
							return [false];
						});
						return { select: v };
					} else if (
						item.validationType.toLowerCase() === 'time' ||
						item.validationType.toLowerCase() === 'date' ||
						item.validationType.toLowerCase() === 'text' ||
						item.validationType.toLowerCase() === 'email' ||
						item.validationType.toLowerCase() === 'number'
					) {
						return '';
					}
					return false;
				}
			});
			if (cssPtag) {
				let value;
				if (
					loadStateSession(`FF-CSSPTAGworkflowData-${noOfTimeCalled}`) !==
					undefined
				) {
					value = loadStateSession(`FF-CSSPTAGworkflowData-${noOfTimeCalled}`);
				}

				if (value) {
					setWorkflowValues(value);
				} else {
					setWorkflowValues(workflowData);
				}
			} else {
				let value;
				if (loadStateSession('FF-workflowData') !== undefined) {
					value = loadStateSession('FF-workflowData');
				}
				if (value) {
					setWorkflowValues(value);
				} else {
					setWorkflowValues(workflowData);
				}
			}
		}
	}, [currentWorkflowData]);

	return (
		<div
			className='ff-getintouch-screen'
			style={{
				position: cssPtag ? 'initial' : 'relative',
				paddingBottom: cssPtag ? '' : '20px',
			}}
		>
			{showErrorToaster && (
				<>
					<div
						style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
					>
						<TOASTER className='ff-toaster' colorMode={colorMode}>
							Something went wrong. Please try again
						</TOASTER>
					</div>
				</>
			)}

			<>
				<div className={cssPtag ? '' : 'ff-chatbot-body2'}>
					{currentWorkflowData.message}
				</div>
				{workflowValues !== undefined ? (
					<FORMS colorMode={colorMode} cssPtag={cssPtag}>
						{sortedWorkflowData.map((list, index) => {
							if (list.enabled.toLowerCase() === 'true') {
								let validator = new RegExp(list.validation, 'i');
								return (
									<div key={index}>
										{list.name ? (
											<>
												<p className='ff-chatbot-body2'>{list.name}</p>
												{list.message ? (
													<p className='ff-chatbot-caption'>{list.message}</p>
												) : null}

												{list.validationType.toLowerCase() === 'text' ? (
													<Input
														autoFocus={index == 0 ? true : false}
														disabled={
															(disableInputs || disableButton) &&
															shouldDisableActions
														}
														error={
															workflowValues[index] &&
															!validator.test(workflowValues[index])
														}
														errorText={
															<div
																style={{
																	display: 'flex',
																	alignItems: 'center',
																	gap: '5px',
																}}
															>
																{InfoIcon(colorMode, cssPtag)}
																<p
																	style={{
																		margin: 0,
																		color: errTextAndIconColor(colorMode),
																	}}
																>
																	Please provide a valid text
																</p>
															</div>
														}
														fullWidth
														value={workflowValues[index]}
														onChange={(e) => {
															let v = [...workflowValues];

															v[index] = e.target.value;

															setWorkflowValues(v);
														}}
													/>
												) : null}
												{list.validationType.toLowerCase() === 'email' ? (
													<Input
														autoFocus={index == 0 ? true : false}
														disabled={
															(disableInputs || disableButton) &&
															shouldDisableActions
														}
														error={
															workflowValues[index] &&
															!validator.test(workflowValues[index])
														}
														errorText={
															<div
																style={{
																	display: 'flex',
																	alignItems: 'center',
																	gap: '5px',
																}}
															>
																{InfoIcon(colorMode, cssPtag)}
																<p
																	style={{
																		margin: 0,
																		color: errTextAndIconColor(colorMode),
																	}}
																>
																	Please provide a valid email address
																</p>
															</div>
														}
														fullWidth
														value={workflowValues[index]}
														onChange={(e) => {
															let v = [...workflowValues];

															v[index] = e.target.value;

															setWorkflowValues(v);
														}}
													/>
												) : null}
												{list.validationType.toLowerCase() === 'date' ? (
													<Input
														autoFocus={index == 0 ? true : false}
														disabled={
															(disableInputs || disableButton) &&
															shouldDisableActions
														}
														error={
															workflowValues[index] &&
															!validator.test(workflowValues[index])
														}
														errorText={
															<div
																style={{
																	display: 'flex',
																	alignItems: 'center',
																	gap: '5px',
																}}
															>
																{InfoIcon(colorMode, cssPtag)}
																<p
																	style={{
																		margin: 0,
																		color: errTextAndIconColor(colorMode),
																	}}
																>
																	Please provide a valid date
																</p>
															</div>
														}
														fullWidth
														placeholder='DD-MM-YYYY'
														type='date'
														value={workflowValues[index]}
														onChange={(e) => {
															let v = [...workflowValues];

															v[index] = e.target.value;

															setWorkflowValues(v);
														}}
													/>
												) : null}
												{list.validationType.toLowerCase() === 'time' ? (
													<Input
														autoFocus={index == 0 ? true : false}
														disabled={
															(disableInputs || disableButton) &&
															shouldDisableActions
														}
														error={
															workflowValues[index] &&
															!validator.test(workflowValues[index])
														}
														errorText={
															<div
																style={{
																	display: 'flex',
																	alignItems: 'center',
																	gap: '5px',
																}}
															>
																{InfoIcon(colorMode, cssPtag)}
																<p
																	style={{
																		margin: 0,
																		color: errTextAndIconColor(colorMode),
																	}}
																>
																	Please provide a valid time
																</p>
															</div>
														}
														fullWidth
														type='time'
														value={workflowValues[index]}
														onChange={(e) => {
															let v = [...workflowValues];
															v[index] = e.target.value;

															setWorkflowValues(v);
														}}
													/>
												) : null}
												{list.validationType.toLowerCase() === 'number' ? (
													<Input
														autoFocus={index == 0 ? true : false}
														disabled={
															(disableInputs || disableButton) &&
															shouldDisableActions
														}
														error={
															workflowValues[index] &&
															!validator.test(workflowValues[index])
														}
														errorText={
															<div
																style={{
																	display: 'flex',
																	alignItems: 'center',
																	gap: '5px',
																}}
															>
																{InfoIcon(colorMode, cssPtag)}
																<p
																	style={{
																		margin: 0,
																		color: errTextAndIconColor(colorMode),
																	}}
																>
																	Please provide a valid phone number
																</p>
															</div>
														}
														// helperText={
														// 	<div
														// 		style={{
														// 			display: 'flex',
														// 			alignItems: 'center',
														// 			gap: '5px',
														// 		}}
														// 	>
														// 		{InfoIcon(colorMode, cssPtag)}
														// 		<p
														// 			style={{
														// 				margin: 0,
														// 				color: errTextAndIconColor(colorMode),
														// 			}}
														// 		>
														// 			Please enter mobile number with country code
														// 		</p>
														// 	</div>
														// }
														fullWidth
														value={workflowValues[index]}
														onChange={(e) => {
															let v = [...workflowValues];

															v[index] = e.target.value;

															setWorkflowValues(v);
														}}
													/>
												) : null}
												{list.validationType.toLowerCase() ===
												'multiple select' ? (
													<>
														{list.options.map((val: any, i) => {
															return (
																<Checkbox
																	disabled={
																		(disableInputs || disableButton) &&
																		shouldDisableActions
																	}
																	label={
																		<p
																			className='ff-chatbot-body2'
																			style={{
																				color:
																					colorMode === 'dark'
																						? 'white'
																						: 'var(--colorScale-1)',
																			}}
																		>
																			{val.name}
																		</p>
																	}
																	isChecked={workflowValues[index].select[i]}
																	index={0}
																	onValueChange={() => {
																		let v = [...workflowValues];
																		v[index].select[i][0] =
																			!v[index].select[i][0];
																		setWorkflowValues(v);
																	}}
																/>
															);
														})}
													</>
												) : null}
												{list.validationType.toLowerCase() ===
												'multiple choice' ? (
													<RadioGroup
														aria-labelledby={'choice' + index + 'label'}
														name={'choice' + index}
														value={workflowValues[index]}
														onChange={(e) => {
															let v = [...workflowValues];
															v[index] = e.target.value;
															setWorkflowValues(v);
															// setInitialState(false)
														}}
													>
														{list.options.map((val: any, i) => (
															<FormControlLabel
																disabled={
																	(disableInputs || disableButton) &&
																	shouldDisableActions
																}
																value={val.name}
																control={<Radio />}
																label={
																	<p
																		className='ff-chatbot-body2'
																		style={{
																			color:
																				colorMode === 'dark'
																					? 'white'
																					: 'var(--colorScale-1)',
																		}}
																	>
																		{val.name}
																	</p>
																}
															/>
														))}
													</RadioGroup>
												) : null}
												{list.validationType.toLowerCase() === 'drop down' ? (
													<>
														<AutoComplete
															disabled={
																(disableInputs || disableButton) &&
																shouldDisableActions
															}
															multiple={false}
															classNameOndropLI='workflowdrop'
															// label=''
															options={list.options.map((opt: any) => {
																return {
																	label: opt.name,
																	value: opt.name,
																};
															})}
															valueKey={'value'}
															labelKey={'label'}
															value={
																workflowValues[index] === ''
																	? {
																			label: list.options[0].name,
																			value: list.options[0].name,
																	  }
																	: workflowValues[index]
															}
															onChange={(val) => {
																let v = [...workflowValues];
																v[index] = val;
																setWorkflowValues(v);
															}}
														/>
													</>
												) : null}
											</>
										) : null}
									</div>
								);
							}
						})}
						<div
							style={{
								display: shouldDisableActions ? 'none' : 'flex',
								gap: '15px',
								marginTop: cssPtag ? '' : '20px',
							}}
							className={cssPtag ? 'ff-inside-form' : ''}
						>
							<Button
								loading={cssPtag ? false : submitLoader}
								fullWidth
								disabled={disableButton ? disableButton : validationCheck()}
								onClick={() => {
									const formObject = {};
									sortedWorkflowData.forEach((item, i) => {
										if (item.enabled.toLowerCase() === 'true') {
											if (item.validationType.toLowerCase() === 'drop down') {
												formObject[item.name] = workflowValues[i].label;
											} else if (
												item.validationType.toLowerCase() === 'multiple choice'
											) {
												formObject[item.name] = workflowValues[i];
											} else if (
												item.validationType.toLowerCase() === 'multiple select'
											) {
												formObject[item.name] =
													workflowValues[i].select &&
													workflowValues[i].select.toString();
											} else if (item.validationType.toLowerCase() === 'time') {
												formObject[item.name] = workflowValues[i];
											} else if (item.validationType.toLowerCase() === 'date') {
												formObject[item.name] = workflowValues[i];
											} else if (item.validationType.toLowerCase() === 'text') {
												formObject[item.name] = workflowValues[i];
											} else if (
												item.validationType.toLowerCase() === 'number'
											) {
												formObject[item.name] = workflowValues[i];
											} else {
												formObject[item.name] = workflowValues[i];
											}
										}
									});
									let data = { form: formObject };
									if (cssPtag) {
										handleSubmit({ metaData: data }, {}, { isHidden: true });
										addUserResponse('Submit', Date.now());
										setDisableButton(true);
									} else {
										setSubmitLoader(true);
										let payload = {
											id: conversationId,
											message: currentWorkflowData.customName,
											botId: botId,
											version: 'prod',
											country: 'US',
											metaData: data,
										};

										let hpayload = {
											q: '',
											fileUpload: {
												uploadedFileDetails: {
													fileName: '',

													fileSize: 0,
												},

												uploadFileStatus: {
													isValidated: false,

													isFileUpload: false,
												},
											},
											apiuser: conversationId,
											mode: 'test',
											version: 'prod',
											botid: EbotId,
											SF_BASE_URL: `${window['BASE_URL']}`,
											source: 'webs',
											lang: lang,
											tenantId: tenantId,
											formData: data,
										};
										let apiname =
											loadStateSession('hybridEnabled').toLowerCase() === 'true'
												? '/HybridChat/chat'
												: loadStateSession('message_api_url') ?? '/messages/';

										fetch('https://' + window['CHAT_URL'] + apiname, {
											credentials: 'include',
											method: 'POST',
											headers: {
												'Content-Type': 'application/json',
												'x-tenant-id': tenantId,
												Authorization: `Bearer ${token}`,
											},
											body: JSON.stringify(
												loadStateSession('hybridEnabled').toLowerCase() ===
													'true'
													? hpayload
													: payload
											),
										})
											.then((data) => data.json())
											.then((res) => {
												if (
													loadStateSession('hybridEnabled').toLowerCase() ===
													'true'
												) {
													setErrorToaster(false);
													setDisableButton(true);
													disableMandatory();
													changeScreen('homescreen');
													showToaster();
													setSubmitLoader(false);
												} else {
													if (res.status.toLowerCase() === 'success') {
														setErrorToaster(false);
														setDisableButton(true);
														disableMandatory();
														changeScreen('homescreen');
														showToaster();
														setSubmitLoader(false);
													}
												}
											})
											.catch((error) => {
												setErrorToaster(true);
												setTimeout(() => {
													setErrorToaster(false);
												}, 3000);
												setSubmitLoader(false);
											});
									}
								}}
							>
								Submit
							</Button>
							{!cssPtag ? null : (
								<Button
									fullWidth
									onClick={() => {
										handleSubmit('Cancel');
										setDisableButton(true);
									}}
								>
									Cancel
								</Button>
							)}
						</div>
					</FORMS>
				) : null}
			</>
		</div>
	);
};

export default GetInTouch;
